import React from 'react';
import { Link } from 'react-router-dom';


const Header = () => (
    <header>
        <Link to="/">Artist Info DB</Link>
    </header>
)

export default Header;